import Utility from '@/utils/Utility'
import PieChart from './PieChart';

export default {
  name: 'TypeOpinionaire',
  components: {
    PieChart
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
    model: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      // chartData: {
      //   labels: [
      //     'Red',
      //     'Blue',
      //     'Yellow'
      //   ],
      //   datasets: [{
      //     data: [300, 50, 100],
      //     backgroundColor: [
      //       'rgb(255, 99, 132)',
      //       'rgb(54, 162, 235)',
      //       'rgb(255, 205, 86)'
      //     ],
      //     hoverOffset: 4
      //   }]
      // },
      chartOptions: {},

      colors: [
        '#5282d8',
        '#8b9ce3',
        '#b9b6ed',
        '#e4cef4',
        '#f0a6c0',
        '#f47c8e',
        '#f04b60',
        '#e57664',
        '#d59b6b',
        '#bfbc73',
      ]
    }
  },
  mounted () {

  },
  computed: {
    // opinionare
    answerList() {
      if (!this.info.enqueteAnswers ||
        !this.info.enqueteAnswers.answerDetails ||
        !this.info.enqueteAnswers.answerDetails.length)
          return []

      const list = this.info.enqueteAnswers.answerDetails
        .map((item, index) => {
          return {
            answerNo: item.answerNo,
            answer: item.answerMessage,
            value: item.answeredLocationsCount,
            // value: index * 4,
            rank: 1,
          }
        })
        .filter(item => item.answer !== null)
        .sort(Utility.sortByKey('value', false))
        .map((item, index) => {
          item.rank = index + 1
          return item
        })

      console.log('answerList', list)
      return list
    },

    chartData() {
      const data = {
        labels: this.answerList.map(item => item.answer),
        datasets: [
          {
            data: this.answerList.map(item => item.value),
            backgroundColor: this.colors.slice(0, this.answerList.length),
            hoverOffset: 4
          }
        ]
      }
      return data
    },

    // sound
    showSoundFile() {
      return this.model.soundFile
    },
    soundFile() {
      return this.model.soundFile
    }
  },
}
